import { Link } from "react-router-dom";
import { Badge } from "./ui/badge";
import { Building2, CheckCircle } from "lucide-react";
import { Button } from "./ui/button";

export const SpecialtyService = () => {
	return (
		<section
			id="civil-engineering"
			className="relative w-full overflow-x-clip bg-gradient-to-tl from-[#00162b] via-[#eaf6ff] to-[#e3f0fa] py-28 md:py-32 px-2"
		>
			{/* Geometric SVG background overlay */}
			<svg
				aria-hidden="true"
				className="pointer-events-none absolute inset-0 z-0 w-full h-full"
				width="100%"
				height="100%"
				viewBox="0 0 1600 900"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				preserveAspectRatio="none"
			>
				{/* Diagonal lines */}
				<g stroke="#00162b" strokeOpacity="0.06" strokeWidth="2">
					<path d="M0 0 L1600 900" />
					<path d="M0 900 L1600 0" />
					<path d="M400 0 L1600 800" />
					<path d="M0 800 L1200 0" />
					<path d="M800 0 L1600 600" />
					<path d="M0 600 L1000 0" />
				</g>
				{/* Dots grid */}
				<g fill="#00162b" fillOpacity="0.07">
					{Array.from({ length: 16 }).map((_, i) =>
						Array.from({ length: 9 }).map((_, j) => (
							<circle
								key={`dot-${i}-${j}`}
								cx={i * 100 + 50}
								cy={j * 100 + 50}
								r="3"
							/>
						))
					)}
				</g>
				{/* Polygons */}
				<polygon
					points="1200,0 1600,0 1600,400"
					fill="#1cb5fc"
					fillOpacity="0.04"
				/>
				<polygon
					points="0,900 0,600 400,900"
					fill="#1cb5fc"
					fillOpacity="0.04"
				/>
			</svg>
			<div className="container max-w-7xl mx-auto relative z-10">
				<div className="flex flex-col-reverse md:flex-row items-center gap-12 md:gap-20">
					{/* Left: Text Content */}
					<div className="flex-1 flex flex-col items-start justify-center text-left max-w-xl">
						<Badge className="mb-4" variant="secondary">
							<Building2 className="h-4 w-4 mr-2" />
							Specialty Service
						</Badge>
						<h2 className="text-4xl md:text-5xl font-extrabold text-navy mb-6 leading-tight drop-shadow-sm">
							Civil Engineering & Site Development
						</h2>
						<p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto">
							Expert civil engineering services for comprehensive site
							development projects throughout Central Texas. From initial site
							analysis to final construction oversight, we deliver optimized
							solutions that meet local requirements and exceed client
							expectations.
						</p>
						<ul className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4 mb-10 w-full">
							<li className="flex items-center gap-3 p-4 bg-white/90 rounded-xl shadow border border-blue/10">
								<CheckCircle className="h-5 w-5 text-blue flex-shrink-0" />
								<span className="text-base font-semibold text-blue-900">
									Civil Engineering
								</span>
							</li>
							<li className="flex items-center gap-3 p-4 bg-white/90 rounded-xl shadow border border-blue/10">
								<CheckCircle className="h-5 w-5 text-blue flex-shrink-0" />
								<span className="text-base font-semibold text-blue-900">
									Water & Wastewater
								</span>
							</li>
							<li className="flex items-center gap-3 p-4 bg-white/90 rounded-xl shadow border border-blue/10">
								<CheckCircle className="h-5 w-5 text-blue flex-shrink-0" />
								<span className="text-base font-semibold text-blue-900">
									Permitting & Compliance
								</span>
							</li>
							{/* <li className="flex items-center gap-3 p-4 bg-white/90 rounded-xl shadow border border-blue/10">
								<CheckCircle className="h-5 w-5 text-blue flex-shrink-0" />
								<span className="text-base font-semibold text-blue-900">
									Construction Management
								</span>
							</li> */}
						</ul>
						<div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
							<Button asChild size="lg" className="p-3 font-bold shadow-xl">
								<a href="#contact">Request Project Quote</a>
							</Button>
							<Button
								size="lg"
								variant="outline"
								asChild
								className="p-3 font-bold shadow-xl"
							>
								<Link to="/civil-engineering">
									Learn More About Civil Engineering
								</Link>
							</Button>
						</div>
					</div>
					{/* Right: Modern Image Card */}
					<div className="flex-1 flex items-center justify-center w-full md:w-auto">
						<div className="relative overflow-hidden shadow-2xl rounded-lg bg-gradient-to-br from-[#eaf6ff] to-[#c6e6fa] aspect-[16/10] max-w-2xl w-full flex items-center justify-center">
							<video
								src="/gova_residential_video.mp4"
								className="absolute inset-0 w-full h-full object-cover"
								autoPlay
								loop
								muted
								playsInline
							/>
							<div className="absolute bottom-6 left-6 bg-blue/90 text-white px-8 py-4 rounded-2xl shadow-lg flex flex-col items-center">
								<div className="text-2xl font-bold leading-none">Central Texas</div>
								<div className="text-sm font-medium opacity-90 tracking-wide">
									Local Requirements Knowledge
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};
